// src/contexts/LightboxContext.js
import React, { createContext, useContext, useState } from 'react';

const LightboxContext = createContext();

export const useLightbox = () => useContext(LightboxContext);

export const LightboxProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  const openLightbox = (url) => {
    setImageSrc(url);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
    setImageSrc('');
  };

  return (
    <LightboxContext.Provider value={{ isOpen, imageSrc, openLightbox, closeLightbox }}>
      {children}
    </LightboxContext.Provider>
  );
};
